import { render, staticRenderFns } from "./UpdateFilter.vue?vue&type=template&id=c28ce1aa&"
import script from "./UpdateFilter.vue?vue&type=script&lang=ts&"
export * from "./UpdateFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports